import clsx from 'clsx';
import { SkeletonBlock } from './SkeletonBlock.tsx';

interface SkeletonAvatarProps {
  className?: string;
}

export function SkeletonAvatar({ className }: SkeletonAvatarProps) {
  return <SkeletonBlock className={clsx('rounded-full', className)} />;
}
